/* @flow */
import React from 'react';

import Dialog from 'components/Dialog.jsx';

class DialogWithSidebar extends React.Component {
  render() {
    return (
      <Dialog
        {...this.props}
        size="xlarge">
        {this.props.children}
      </Dialog>
    );
  }
}

export default DialogWithSidebar;



// WEBPACK FOOTER //
// ./src/components/DialogWithSidebar.jsx